module.exports = __webpack_public_path__ + "img/device-Information_0_v1.b66f5834.png";